<template>
  <div class="icon-wrapper p-0 m-0">
    <svg class="icon p-0 m-0" :width="width" :height="height">
      <use
        v-if="name != ''"
        v-bind="{ 'xlink:href': '/feather-sprite.svg#chevron-' + name }"
      ></use>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    width: {
      type: [Number, String],
      default: 30,
    },
    height: {
      type: [Number, String],
      default: 30,
    },
  },
};
</script>

<style scoped>
.icon-wrapper {
  display: inline-flex;
  align-items: center;
  color: #282c5a;
}
.icon {
  position: relative;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
  margin-right: 6px;
  color: #2bfed1;
  top: 7px;
}
</style>
